import { defineStore } from 'pinia'

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface Toast {
  id: number
  message: string
  type: ToastType
}

// Contador propio en vez de Date.now(): varios toasts emitidos en el mismo tick
// (p. ej. los warnings de un PUT seguido de su PATCH) colisionarían de id y el
// primer timeout se llevaría al segundo.
let toastSeq = 0

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [] as Toast[],
  }),
  actions: {
    add({ message, type = 'success', duration = 3500 }: { message: string; type?: ToastType; duration?: number }) {
      const id = ++toastSeq
      this.toasts.push({ id, message, type })
      setTimeout(() => this.remove(id), duration)
    },
    remove(id: number) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    },
  },
})
